module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-16.46e1dee8.png";